export default {
    player: {
        speed: "מהירות השמעה"
    },
    footer: {
        copy: "{{year}} הדף בעיון"
    },
    partners: {
        heading: "אנו מודים לתורמים שלנו"
    },
    newsletter: {
        heading: "הירשם לקבלת השיעור היומי",
        signUp: "הירשם",
        thanks: "תודה שנרשמת."
    },
    auth: {
        welcome:
            "ברוך הבא להדף בעיון .אנא הירשם / היכנס להורדה, עקוב אחר מגידי השיעורים ושמור שיעורים לספריה שלך. כל השיעורים בחינם. אנו מקווים שתיהנו מהשיעורים",
        subtitle:
            'לא נשתף את המידע שלך עם אף אחד. בלחיצה על כפתור ההרשמה]הרשמה אתה מסכים לקבל מדי פעם הודעות דוא"ל מהדף בעיון.',
        confirmation:
            'שלחנו קישור אישור לכתובת הדוא"ל הרשומה שלך ({{email}}). אשר את הדוא"ל שלך להשלמת ההרשמה שלך.',
        verifyModalTitle: "אמת את הטלפון שלך",
        verifyModalText: "Dear listener,<br/>We have made a few changes and updated our login/register system. We're sorry for the inconvenience but all phone numbers must be re-verified to use the system. We hope you continue to enjoy the shiurim.<br/>Hadaf Beiyun",
        verifyModalOkTitle: "אמת עכשיו",
        verifyModalCancelTitle: "אמת מאוחר יותר",
        phoneFieldDescription: 'Alphabets, dashes and other special characters are not allowed.',
        registerPhoneFieldDescription: 'אנא הקפד להזין את מספר הטלפון הנכון. תצטרך לאמת את הטלפון שלך כדי להירשם.'
    },
    search: {
        heading: "חיפוש בהדף בעיון",
        found: "נמצאו {{012345}} תוצאות עבור ",
        showPerPage: "מספר תוצאות לעמוד:",
        shasShiurim: 'שיעורים על הש"ס'
    },
    speakerTab: {},
    bio: {
        follow: {
            tooltip:
                'במעקב אחר מגיד שיעור אתה נרשם לקבלת עדכונים על השיעורים  שלו לדוא"ל.'
        }
    },
    magideiShiurList: {
        filterLabel: "סנן מגידי שיעורים על תורה",
        filterMagidShiur: "סנן מגידי שיעורים"
    },
    savedShiurim: {
        heading: "שיעורים שמורים",
        bookmarkCaption:
            "תוכלו להוסיף סימניות לשיעורים המועדפים שלכם והם יופיעו כאן"
    },
    inProgressShiurim: {
        heading: "שיעורים בעיצומה",
        bookmarkCaption:
            "השיעורים שצפיתם בהם ולא סיימתם יופיעו כאן."
    },
    followingSpeaker: {
        heading: "במעקב אחר מגיד שיעור [זה]",
        howOften:
            '? באיזו תדירות תרצה לקבל עדכוני שיעורים חדשים ממגידי שיעור אלה באמצעות דוא"ל',
        caption: "תוכלו לעקוב אחרי המגידי שיעורים האהובים עליכם והם יופיעו כאן"
    },
    contactForm: {
        heading: "הערות והצעות",
        validationMessage: "זהו שדה חובה ועליו להכיל לפחות 3 תווים",
        requiredMessage: "זהו שדה חובה.",
        successMessage: "תודה על ההודעה שלך, אנו נחזור אליך בהקדם האפשרי"
    },
    masechtos: {
        selectMasechta: "בחר מסכת"
    },
    seder: {
        heading: "סדר {{ name }}"
    },
    masechta: {
        volume: "חלק {{ number }}",
        dedicatedBy: "נתרם על ידי:",
        anonymous: "אנונימי  החפץ בעילום שמו",
        downloadMasechta: "הורדת המסכת {{ name}} עם מראי מקומות",
        downloadAllMasechta: "הורדת כל המסכת {{masechta.name}} עם מראי מקומות",
        downloadVolMasechta:
            "הורדת המסכת {{ name }} חלק. {{ vol }} עם מראי מקומות",
        downloadVol: "הורדת חלק {{ num }}"
    },

    serverTable: {
        count:
            "מציג {from} ל- {to} מתוך {count} רשומות|{count} רשומות|One Record",
        first: "ראשון",
        last: "אחרון",
        filter: "סנן:",
        filterPlaceholder: "שאילתת חיפוש",
        limit: "רשומות:",
        page: "עמוד:",
        noResults: "אין רשומות תואמות",
        filterBy: "סנן לפי {column}",
        loading: "טעינה...",
        defaultOption: "בחר  {column}",
        columns: "עמודות",
        records: "אין הקלטות"
    }
};
